export const isValueEmpty = value => {
  return Array.isArray(value) ? value.length < 1 : !value;
};